import { AutoAwesomeOutlined } from "@mui/icons-material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "../../../components/UIToolkit/molecules/EmptyState";
import SystemButton from "../../../components/UIToolkit/SystemButton/SystemButton";

type Props = {
	canEdit: boolean;
	/** Puts the example request into the design chat. */
	onUseSuggestion: (prompt: string) => void;
};

/** The department has no custom printouts yet: say how to get one, with an example request to start from. */
export const CustomPrintoutListEmpty: FC<Props> = ({ canEdit, onUseSuggestion }) => {
	const { t } = useTranslation();
	return (
		<EmptyState
			dataTestId="custom-printout-list-empty"
			icon={<AutoAwesomeOutlined />}
			title={t("printout.custom.ai.list.empty.title")}
			hint={canEdit ? t("printout.custom.ai.list.empty.hint", { example: t("printout.custom.ai.suggestion") }) : t("printout.custom.ai.list.empty.hint.view")}
			action={
				canEdit && (
					<SystemButton
						data-testid="custom-printout-suggestion"
						buttonVariant="borderless"
						size="small"
						noFullWidthMobile
						leadingIcon={<AutoAwesomeOutlined />}
						onClick={() => onUseSuggestion(t("printout.custom.ai.suggestion"))}
					>
						{t("printout.custom.ai.suggestion.use")}
					</SystemButton>
				)
			}
			sx={{ py: 1 }}
		/>
	);
};
